import { render } from "./FireHeader.vue?vue&type=template&id=17a96ec7"
import script from "./FireHeader.vue?vue&type=script&lang=ts"
export * from "./FireHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script